var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[
    'material-symbols-outlined',
    'success-icon',
    _vm.className
  ]},[_vm._v("\n  check\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }